export default __webpack_public_path__ + "static/media/equipe_cropped.d7cab097.jpg";